import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Input - Text input component
 *
 * THEMING: Uses semantic color classes.
 * Each app should define these in tailwind.config:
 *   - primary (for focus states)
 *   - danger (for error states)
 */
import { forwardRef } from 'react';
export const Input = forwardRef(({ label, error, helperText, icon: Icon, className = '', ...props }, ref) => {
    return (_jsxs("div", { className: "space-y-1", children: [label && (_jsx("label", { className: "block text-sm font-medium text-slate-700 dark:text-slate-200", children: label })), _jsxs("div", { className: "relative", children: [Icon && (_jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none", children: _jsx(Icon, { className: "w-5 h-5 text-slate-400" }) })), _jsx("input", { ref: ref, className: `
                        block w-full rounded-lg border transition-colors duration-200
                        bg-white dark:bg-slate-900
                        ${Icon ? 'pl-10' : 'pl-4'} pr-4 py-2.5
                        ${error
                            ? 'border-danger-300 focus:border-danger-500 focus:ring-danger-500'
                            : 'border-slate-300 dark:border-slate-600 focus:border-primary-500 focus:ring-primary-500'}
                        focus:outline-none focus:ring-2 focus:ring-opacity-20
                        placeholder:text-slate-400
                        text-slate-900 dark:text-white
                        ${className}
                    `, ...props })] }), error && (_jsx("p", { className: "text-sm text-danger-600", children: error })), helperText && !error && (_jsx("p", { className: "text-sm text-slate-500", children: helperText }))] }));
});
Input.displayName = 'Input';
export default Input;
